module.exports = __webpack_public_path__ + "static/media/2025_aufhaenger_hoch.582e19f4.png";